var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-toggle-component" }, [
    _c("input", {
      staticClass: "v-toggle-input",
      attrs: { type: "checkbox", id: _vm.id, name: _vm.id },
      domProps: { checked: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("update:value", $event.target.checked)
        },
      },
    }),
    _c("label", { staticClass: "v-toggle-label", attrs: { for: _vm.id } }, [
      _c("div", { staticClass: "v-toggle-label-text-wrapper" }, [
        _c(
          "p",
          { staticClass: "v-toggle-label-text", class: { simple: _vm.simple } },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _c("div", { staticClass: "explanation-wrapper" }, [
          _c("p", { staticClass: "explanation-text" }, [
            _vm._v(_vm._s(_vm.explanation)),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "v-toggle-button",
          class: [
            [_vm.value ? "on" : "off"],
            { simple: _vm.simple },
            _vm.color,
          ],
        },
        [
          !_vm.simple
            ? _c("span", { staticClass: "v-toggle-button-text" }, [
                _vm._v(_vm._s(_vm.text)),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }